import React, { useState } from 'react';
import { mockOpportunity } from '../data/mockOpportunity';
import { useOpportunityStatus } from '../hooks/useOpportunityStatus';
import { OpportunityBanner } from '../components/OpportunityBanner';
import { TakeActionModal } from '../components/TakeActionModal';
export function OpportunityPage() {
  const [opportunity, setOpportunity] = useState(mockOpportunity);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const bannerState = useOpportunityStatus(opportunity);
  return <div className="min-h-screen bg-gray-50 flex flex-col w-full" data-id="element-106">
      <OpportunityBanner state={bannerState} onTakeAction={() => setIsModalOpen(true)} data-id="element-107" />
      <TakeActionModal opportunity={opportunity} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={updated => setOpportunity(updated)} data-id="element-108" />
    </div>;
}